import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import DataTable from "@/components/DataTable";
import { fmtDateTime } from "@/lib/format";

const ACTION_LABELS = {
  "company.created": "Company onboarded",
  "subscription.assigned": "Subscription assigned",
  "subscription.payment_recorded": "Subscription payment recorded",
  "project.created": "Project created",
  "update.published": "Update published",
  "alert.broadcast": "Alert broadcast",
  "customer.created": "Customer created",
  "customer.invite_resent": "Customer invite resent",
  "invite.accepted": "Invite accepted",
};

export default function PlatformAudit() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/platform/audit")
      .then((r) => setItems(r.data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-8" data-testid="platform-audit-page">
      <PageHeader
        eyebrow="Compliance"
        title="Audit log"
        description="Timeline of key actions across all tenants."
      />

      <DataTable
        testId="platform-audit-table"
        columns={[
          { key: "created_at", label: "When", render: (r) => fmtDateTime(r.created_at) },
          {
            key: "action",
            label: "Action",
            render: (r) => (
              <div>
                <div className="font-bold">{ACTION_LABELS[r.action] || r.action}</div>
                <div className="text-xs text-stone-400 font-mono">{r.action}</div>
              </div>
            ),
          },
          { key: "entity_type", label: "Entity", render: (r) => <span className="font-mono text-xs uppercase">{r.entity_type}</span> },
          {
            key: "actor",
            label: "Actor",
            render: (r) => (
              <div>
                <div className="font-semibold">{r.actor_name || r.actor_email || "—"}</div>
                <div className="text-xs text-stone-400 font-mono">{r.actor_role}</div>
              </div>
            ),
          },
          {
            key: "company_name",
            label: "Tenant",
            render: (r) => r.company_name || <span className="text-stone-400">—</span>,
          },
          {
            key: "details",
            label: "Details",
            render: (r) =>
              r.details && Object.keys(r.details).length > 0 ? (
                <code className="text-xs text-stone-600">{JSON.stringify(r.details)}</code>
              ) : (
                "—"
              ),
          },
        ]}
        rows={items}
        empty={loading ? "Loading…" : "No audit entries yet."}
      />
    </div>
  );
}
